import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { DateUtility } from 'src/app/utils/date-utility';
import { HttpClientService } from '../core';

@Injectable({
  providedIn: 'root',
})
export class VeteranService {
  constructor(private httpClient: HttpClientService) {}

  guideClickTracking(clickData: any) {
    return this.httpClient.post('/student/guide/tracking', clickData).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  getMatchedColleges(studentid: string) {
    const newdate = DateUtility.format(new Date(), 'MMddyyyy_HHmmss');
    return this.httpClient
      .get('/matched/collegelist/' + studentid + '?dt=' + newdate)
      .pipe(
        map((response: any) => {
          return response.data;
        }),
      );
  }

  getMatchedPercentOfCollege(studentid: string, collegeid: string) {
    const newdate = DateUtility.format(new Date(), 'MMddyyyy_HHmmss');
    return this.httpClient
      .get(
        '/college/matched-percent/' +
          studentid +
          '/' +
          collegeid +
          '?dt=' +
          newdate,
      )
      .pipe(
        map((response: any) => {
          return response.data;
        }),
      );
  }

  getPaidMatchedColleges(studentid: string) {
    const newdate = DateUtility.format(new Date(), 'MMddyyyy_HHmmss');
    return this.httpClient
      .get('/paid/matched/collegelist/' + studentid + '?dt=' + newdate)
      .pipe(
        map((response: any) => {
          return response.data;
        }),
      );
  }

  veteranReplyMessage(messageInfo: any) {
    return this.httpClient.post('/student/replymessage', messageInfo).pipe(
      map((response: any) => {
        return response.data;
      }),
    );
  }

  updateSavedCollegeData(updateData: any) {
    return this.httpClient
      .post('/register/saved/update/collegelist', updateData)
      .pipe(
        map((response: any) => {
          return response;
        }),
      );
  }

  updatePhoneInfo(phoneInfo: any) {
    return this.httpClient.post('/student/update/phonenumber', phoneInfo).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  saveMatchedCollegeData(matchData: any) {
    return this.httpClient
      .post('/register/match/save/collegelist', matchData)
      .pipe(
        map((response: any) => {
          return response;
        }),
      );
  }

  sentRequestInfoEmail(emailData: any) {
    return this.httpClient.post('/student/requestinfo/email', emailData).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  getFeatureColleges(studentid: any) {
    const newdate = DateUtility.format(new Date(), 'MMddyyyy_HHmmss');
    return this.httpClient
      .get('/student/featureschool/' + studentid + '?dt=' + newdate)
      .pipe(
        map((response: any) => {
          return response.data;
        }),
      );
  }

  getVeteranBucketInfo(studentid: any) {
    const newdate = DateUtility.format(new Date(), 'MMddyyyy_HHmmss');
    return this.httpClient
      .get('/student/bucketinfo/' + studentid + '?dt=' + newdate)
      .pipe(
        map((response: any) => {
          return response.data;
        }),
      );
  }

  submitLead(formData: any) {
    console.log('FOPRMM DATA', formData);
    return this.httpClient
      .post('/student/tcpa/submit-lead', formData)
      .subscribe({
        next: (response: any) =>
          console.log('Lead Submitted Successfully:', response),
        error: (err: any) => console.error('Error submitting lead:', err),
      });
  }
}
